import { ReactElement, useEffect, useState } from 'react'
import { T } from "react-translator-component";
import { Box, Button, FormControl, MenuItem, Select } from '@mui/material';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import appServices from '../../../services/app-services/appServices';
import { convertUserImage } from '../../../util/utils';
import LoadingModal from '../../../components/LoadingModal';
import IconButtonArrow from '../../../components/GreenCity/IconButtonArrow';
import { colors } from '../../../common/colors';
import profile from "../../../assets/images/profile_img.png";

interface Props {
  onNext: (group: any) => void;
  groupId?:string,
  eventId?:string,
  owner?:any,
}

function SeclectUser({ onNext, groupId, eventId, owner}: Props): ReactElement {
  const [isLoading, setIsLoading]=useState<boolean>(false);
  const [users, setUsers]=useState<any[]>([]);
  const [events, setEvents]=useState<any[]>([])
  const [event, setEvent]=useState<any>({id:'',title:''})
  const [selectedUser, setSelectedUser]=useState<any>();

  useEffect(()=>{
    apiCalls();
  },[])

  const apiCalls = async () => {
    setIsLoading(true);
    try {
      if (groupId) {
        const data = await appServices.getMemberList(groupId);
        setUsers(data.member_group_users);
      } else if (eventId) {
        const data = await appServices.getEventListByMemberGroup(Number(eventId));
        setEvents(data.post_events)
        setEvent(data.post_events[0].id)
        if (data.post_events[0].users) {
          setUsers(data.post_events[0].users);
        }
      }

      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
    }
  };

  const handleSubmit = ()=> {
    if(groupId){
      if(selectedUser?.user){
        onNext(selectedUser?.user)
      } else {
        onNext(selectedUser)
      }
    } else {
      onNext(selectedUser)
    }
  }

  const handleGroup = (user:any) => {
    setSelectedUser(user)
  }

  const handleChange = async (event:any) => {
    setEvent(event.target.value);
    const eventDetails :any= events.find((e:any) => e?.id === event.target.value);
    if(eventDetails?.users) {
      setUsers(eventDetails?.users);
    }
  }

  return (
    <div style={{height:320,width:'100%',backgroundColor:'whitesmoke',margin:6,padding:4,border:'2px solid gray' ,borderRadius:10}}>
      <Box display="flex" flexDirection="column" sx={{height:260,width:'100%',overflow:'scroll'}}>
        {eventId && (
          <FormControl sx={{ m: 1, minWidth: 120 }}>
            <Select
              value={event}
              onChange={handleChange}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {events?.map((event: any, index: number) => (
                <MenuItem value={event.id} key={index}>{event.title}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {groupId ? (
          <>
            <IconButtonArrow
              borderColor={!(selectedUser?.user) && owner.id === selectedUser?.id ? colors.farm_green500 : colors.farm_gray100}
              key={owner}
              icon={
                <img
                  alt=""
                  height={26}
                  width={26}
                  style={{ borderRadius: 13 }}
                  src={owner?.image ? convertUserImage(owner?.image) : profile}
                />
              }
              title={owner?.nickname || owner?.name}
              onClick={() => handleGroup(owner)}
            />

            {users?.map((group: any, index: number) => (
              <IconButtonArrow
                borderColor={selectedUser?.user && group?.user?.id === selectedUser?.user?.id ? colors.farm_green500 : colors.farm_gray100}
                key={index}
                icon={
                  <img
                    alt=""
                    height={26}
                    width={26}
                    style={{ borderRadius: 13 }}
                    src={group?.user?.image ? convertUserImage(group?.user?.image) : profile}
                  />
                }
                title={group?.user?.nickname || group?.user?.name}
                onClick={() => handleGroup(group)}
              />
            ))}
          </>
        ) : (
          <>
            {users?.map((user: any, index: number) => (
              <IconButtonArrow
                borderColor={user?.id === selectedUser?.id ? colors.farm_green500 : colors.farm_gray100}
                key={index}
                icon={
                  <img
                    alt=""
                    height={26}
                    width={26}
                    style={{ borderRadius: 13 }}
                    src={user?.image ? convertUserImage(user?.image) : profile}
                  />
                }
                title={user?.nickname || user?.name } // Title from the group
                onClick={() => handleGroup(user)}
              />
            ))}
          </>
        )}
      </Box>

      <Button
        color="secondary"
        sx={styles.submitButton}
        size={"large"}
        variant="outlined"
        onClick={handleSubmit}
        endIcon={
          <FontAwesomeIcon
            style={{ position: "absolute", top: 0, right: 0, margin: "10px" }}
            icon={faChevronRight}
          />
        }
      >
        {T("next")}
      </Button>

      <LoadingModal visible={isLoading} />
    </div>
  )
}

const styles = {
  submitButton: {
    width: "80%",
    alignSelf: "center",
    margin: "0 auto",
    display: "flex",
    borderRadius: 20,
    border: "2px solid",
    marginBottom: 8,
  },
};

export default SeclectUser
